<template>
  <div>
    <hero-header :page-name="palyazat.title" hero-title="competition"></hero-header>
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="mb-10" style="font-family: Garamond, Roboto, Helvetica, Arial, sans-serif; font-size: 18px;">
          <PalyazatContentItem v-for="(contentItem, contentItemIndex) in palyazat.content"
                               :title="contentItem.title"
                               :text="contentItem.text"
                               :use-p="contentItem.useP"
                               :html-text="contentItem.htmlText"
                               :img="contentItem.img"
                               :key="contentItemIndex"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
// eslint-disable-next-line import/extensions
import PalyazatContentItem from '@/components/Palyazat/PalyazatContentItem';

export default {
  name: 'PalyazatPage',
  components: {
    heroHeader,
    PalyazatContentItem,
  },
  props: {
    //
  },
  async beforeMount() {
    // eslint-disable-next-line no-console
    const palyazat = await this.$store.dispatch('getCompetitionByTitle', this.$route.params.title);
    this.palyazat = palyazat;
  },
  data() {
    return {
      palyazat: [],
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
